var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8752 0H3.4C1.64 0 0.199997 1.44 0.199997 3.2V28.8C0.199997 30.56 1.64 32 3.4 32H22.6C24.36 32 25.8 30.56 25.8 28.8V10.9248C25.8 10.0768 25.4624 9.2624 24.8624 8.6624L17.1376 0.9376C16.5376 0.3376 15.7232 0 14.8752 0ZM17.8 25.6H8.2C7.3168 25.6 6.6 24.8832 6.6 24C6.6 23.1168 7.3168 22.4 8.2 22.4H17.8C18.6832 22.4 19.4 23.1168 19.4 24C19.4 24.8832 18.6832 25.6 17.8 25.6ZM17.8 19.2H8.2C7.3168 19.2 6.6 18.4832 6.6 17.6C6.6 16.7168 7.3168 16 8.2 16H17.8C18.6832 16 19.4 16.7168 19.4 17.6C19.4 18.4832 18.6832 19.2 17.8 19.2ZM14.6 11.2V2.4L23.4 11.2H14.6Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.ff5cc55500283bb49d6f92cda225f4af.svg";
export { ForwardRef as ReactComponent };